// ThaidCallback.js
import React, { useEffect, useState, useContext } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
// auth
import AuthThaID from '../../../services/auth.thaid';

// context
import UserContext from '../../../context/UserContext';

const ThaidCallback = () => {
  const [error, setError] = useState(null);
  const location = useLocation();
  const history = useHistory();

  const { setProfile } = useContext(UserContext);
  const [, updateState] = React.useState();
  const forceUpdate = React.useCallback(() => updateState({}), []);

  const [state, setState] = React.useState({
    username: '',
    password: '',
    error: false,
  });

  const getParamQuery = () => {
    const query = new URLSearchParams(window.location.search);
    return query.get('ref') !== null && query.get('ref') !== '' ? query.get('ref') : '/';
  };
  useEffect(() => {
    // Extract the token from the URL
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get('auth'); // Assuming the token is in the 'auth' query parameter

    if (token) {
      AuthThaID.login(token).then(
        () => {
          setState({ ...state, error: false });
          setProfile({ isLogin: true });
          forceUpdate();

          const currentRef = getParamQuery();
          // Perform redirection AFTER the log
          if (currentRef !== '/') {
            window.location.href = currentRef;
          } else {
            history.push(`/${process.env.REACT_APP_PATH}`);
            // window.location.href = '/';
          }
        }
      ).catch((error) => {
        // Catch and log any errors from test.login
        console.error('Login error:', error);
      });
    } else {
      setError('No token found in the URL');
    }
  }, [location.search]);

  // Handle loading and error states
  if (error) {
    return <div>Error: {error}</div>;
  }

  if (AuthThaID.isLogin()) {
    return false;
  }

  return null;
};

export default ThaidCallback;
